export const GET_PRODUCT_CARD_REQUEST = 'GET_PRODUCT_CARD_REQUEST';
export const GET_PRODUCT_CARD_SUCCESS = 'GET_PRODUCT_CARD_SUCCESS';
export const GET_PRODUCT_CARD_FAILURE = 'GET_PRODUCT_CARD_FAILURE';
export const DECREASE_STOCK_PRODUCT = 'DECREASE_STOCK_PRODUCT';
export const SET_PRODUCT_CARD_INITIAL_STATE = 'SET_PRODUCT_CARD_INITIAL_STATE';
